module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.exit
    }
  }, [_c('v-icon', [_vm._v("clear")])], 1), _vm._v(" "), (_vm.newUser) ? _c('v-toolbar-title', [_vm._v("Add User")]) : _c('v-toolbar-title', [_vm._v("Edit User")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.canModify && !_vm.newUser) ? _c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "dark": "",
      "color": "green"
    },
    on: {
      "click": function($event) {
        _vm.showResetDialog = true
      }
    }
  }, [_vm._v("Reset Password")]) : _vm._e(), _vm._v(" "), (_vm.canModify) ? _c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "dark": "",
      "color": "blue"
    },
    on: {
      "click": _vm.saveUser
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.canModify && !_vm.newUser) ? _c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "dark": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        _vm.showDeleteDialog = true
      }
    }
  }, [_vm._v("Delete")]) : _vm._e()], 1), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formValid),
      callback: function($$v) {
        _vm.formValid = $$v
      },
      expression: "formValid"
    }
  }, [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "input",
      "label": "Name",
      "rules": [_vm.ruleRequired],
      "disabled": !_vm.canModify
    },
    model: {
      value: (_vm.user.name),
      callback: function($$v) {
        _vm.$set(_vm.user, "name", $$v)
      },
      expression: "user.name"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "input",
      "label": "Username",
      "rules": [_vm.ruleEmail],
      "disabled": !_vm.canModify
    },
    model: {
      value: (_vm.user.username),
      callback: function($$v) {
        _vm.$set(_vm.user, "username", $$v)
      },
      expression: "user.username"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.roles,
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "chips": "",
      "label": "User Roles",
      "rules": [_vm.ruleOnePlus],
      "disabled": !_vm.canModify
    },
    model: {
      value: (_vm.user.roles),
      callback: function($$v) {
        _vm.$set(_vm.user, "roles", $$v)
      },
      expression: "user.roles"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Limit Viewable Categories"
    },
    model: {
      value: (_vm.limitUserVisibility),
      callback: function($$v) {
        _vm.limitUserVisibility = $$v
      },
      expression: "limitUserVisibility"
    }
  }), _vm._v(" "), (_vm.limitUserVisibility) ? [_c('v-divider', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "items": _vm.availableCategories,
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "chips": "",
      "label": "Viewable Categories",
      "disabled": !_vm.canModify,
      "click": _vm.userSettings
    },
    model: {
      value: (_vm.userSettings.viewableCategories),
      callback: function($$v) {
        _vm.$set(_vm.userSettings, "viewableCategories", $$v)
      },
      expression: "userSettings.viewableCategories"
    }
  })] : _vm._e()], 2), _vm._v(" "), (_vm.newUser) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Send User Activation Email"
    },
    model: {
      value: (_vm.sendEmail),
      callback: function($$v) {
        _vm.sendEmail = $$v
      },
      expression: "sendEmail"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.newUser && !_vm.sendEmail) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "input",
      "label": "Password",
      "required": "",
      "rules": [_vm.rulePassword],
      "type": "password",
      "counter": "",
      "min": _vm.passwordLength
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  }, [_vm._v("\n            >")])], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "400px"
    },
    model: {
      value: (_vm.showDeleteDialog),
      callback: function($$v) {
        _vm.showDeleteDialog = $$v
      },
      expression: "showDeleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Confirm Delete")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to delete this user?  "), _c('b', [_vm._v("This action cannot be undone.")])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDeleteDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        return _vm.deleteUser()
      }
    }
  }, [_vm._v("I'm Sure")])], 1)], 1)], 1), _vm._v(" "), _c('password-reset', {
    attrs: {
      "user": _vm.user,
      "endpoint": _vm.endpoint
    },
    model: {
      value: (_vm.showResetDialog),
      callback: function($$v) {
        _vm.showResetDialog = $$v
      },
      expression: "showResetDialog"
    }
  }), _vm._v(" "), _c('error-snackbar', {
    model: {
      value: (_vm.errorText),
      callback: function($$v) {
        _vm.errorText = $$v
      },
      expression: "errorText"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed429322","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserEdit.vue
// module id = 457
// module chunks = 1